/**
 * Client do BFF para o "Esqueci minha senha" por SMS
 * (`POST /api/password-reset/sms`, spec `reset-password-sms`).
 *
 * O BFF sempre responde igual, tenha ou não conta ou telefone: a tela só
 * distingue "pedido aceito", "muitos pedidos" e "falhou". Nada aqui lança.
 */

export type PasswordResetSmsResult = 'ok' | 'rate_limited' | 'failed'

const BASE = (
  import.meta.env.VITE_ACCOUNT_API_BASE || 'https://alelo-sit-api.ysec-technology.workers.dev'
).replace(/\/+$/, '')

export async function requestPasswordResetSms(cpf: string): Promise<PasswordResetSmsResult> {
  const url = `${BASE}/api/password-reset/sms`
  let response: Response
  try {
    response = await fetch(url, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ cpf: cpf.replace(/\D/g, '') }),
    })
  } catch (err) {
    console.error('[password-reset-sms] falha de rede em', url, err)
    return 'failed'
  }
  if (response.status === 429) return 'rate_limited'
  if (!response.ok) {
    console.error('[password-reset-sms] respondeu', response.status)
    return 'failed'
  }
  return 'ok'
}
